const translations = {
    connect: 'Connect',
    disconnect: 'Disconnect',
    fieldViewDescription:
        'This connection allows you to send application maps directly to the FieldView inbox.',
    fieldViewTitle: 'Climate FieldView™'
};

export default translations;
